<template>
  <div style="width:100%">
    <div class="topButtDiv" style="">
      <div class="topSearchDiv" style="display: inline-block">
        <AutoComplete
          v-model="keyword"
          :data="autoData"
          slot="prepend"
          size='default'
          :placeholder="OrgMsg.searchPlaceHolder"
          transfer
          @on-change="autoSchoolList(keyword)"
          clearable
          @on-clear="clearSelect"
          class="myAutoInput"
          style="width:350px"></AutoComplete>
        <Button size='default' type='primary' icon="ios-search" @click.native='searchFn' class='searchBut'>{{OrgMsg.search}}</Button>
      </div>
      <Button size='default' type='info' icon="md-add" @click.native='add' class='createNewOrg'>{{OrgMsg.createOrg}}</Button>
    </div>
    <!--表格-->
    <Table size='default' class='activeList' ref="selection" border :loading='isLoading' highlight-row :columns="columns1" :data="data1" ></Table>
    <Page :total="totalCount" :current='currPage' :page-size="pageSize" :page-size-opts='pageSizeOpts' show-sizer show-elevator show-total transfer @on-change="pageChange" @on-page-size-change="pageSizeChange" :max-height="tableHeight"/>
    <OrgModal :is-org-modal.sync="isOrgModal" :is-edit="isEdit" v-if="isOrgModal" @change="searchFn" :modalData="modalData"></OrgModal>
  </div>
</template>

<script>
import { Page, Table, AutoComplete } from 'view-design'
import { handleResAuthor, handleRes } from '@/js/public'
import { OrgMsgCn as OrgMsg } from '../../components/super/orgModoule/info'
import OrgModal from '@/components/super/orgModoule/OrgModal'
import { orgList, getOrgList, orgRemove, getSuperOrg } from '@/api/getApi'
import { mapState } from "vuex"
export default {
  name: 'orgList',
  components: { Page, Table, OrgModal, AutoComplete },
  data () {
    return {
      OrgMsg: OrgMsg,
      isLoading: false,
      status: null,
      isOrgModal: false,
      isEdit: false,
      orgItemData: {},
      data1: [],
      columns1: [
        {
          title: '序号',
          type: 'index',
          width: 40,
          align: 'center'
        },
        {
          title: OrgMsg.name,
          key: 'name',
          align: 'center',
          minWidth: 120,
          render: (h, params) => {
            return <div>
              <a domPropsInnerHTML={this.data1[params.index].school} onClick={() => this.goCaseList(params.index)}></a>
            </div>
          }
        },
        {
          title: OrgMsg.principal,
          key: 'name',
          align: 'center',
          minWidth: 90,
          type: 'html'
        },
        {
          title: OrgMsg.mobile,
          key: 'mobile',
          align: 'center',
          minWidth: 100,
          type: 'html'
        },
        {
          title: OrgMsg.telephone,
          key: 'telephone',
          align: 'center',
          minWidth: 110,
          type: 'html'
        },
        {
          title: OrgMsg.department,
          key: 'department',
          align: 'center',
          minWidth: 90,
          type: 'html'
        },
        {
          title: OrgMsg.position,
          key: 'position',
          align: 'center',
          minWidth: 90,
          type: 'html'
        },
        {
          title: OrgMsg.orgCode,
          key: 'reader_org_id',
          align: 'center',
          minWidth: 90,
          type: 'html'
        },
        {
          title: OrgMsg.actID,
          key: 'reader_act_id',
          align: 'center',
          minWidth: 90,
          type: 'html'
        },
        {
          title: OrgMsg.create_at,
          key: 'create_at',
          align: 'center',
          minWidth: 150,
          render: (h, params) => {
            return <div domPropsInnerHTML={this.data1[params.index].created_at}>
              <div></div>
            </div>
          }
        },
        {
          title: '操作',
          minWidth: 150,
          align: 'center',
          key: 'handle',
          render: (h, params) => {
            return <div>
              <Button size='default' icon="md-create" type='primary' nativeOnClick={() => this.edit(params.index)}>编辑</Button>
              <Button size='default' icon="md-close" type='error' onClick={() => this.deleteItem(params.index)}>删除</Button>
            </div>
          }
        }
      ],
      autoData: [],
      originData: [],
      orgCodeAll: [],
      actIDAll: [],
      schoolDataList: [],
      keyword: '',
      currPage: 1,
      pageSize: 10,
      pageSizeOpts: [10, 20, 50, 100],
      totalCount: 0,
      modalData: {}
    }
  },
  methods: {
    // 点击搜索
    async searchFn () {
      if (this.isLoading) {
        return
      }
      this.currPage = 1
      this.getList()
    },
    async pageChange (data) {
      this.currPage = data
      this.getList()
    },
    // 页面条数变化
    async pageSizeChange (pageSize) {
      this.pageSize = pageSize
      if (this.currPage === 1) {
        this.getList()
      }
    },
    // -> 去机构列表
    goCaseList (index) {
      const { href } = this.$router.resolve({ path: `/admin/userInfo?id=${this.data1[index].university_id}&org_id=${this.data1[index].org_id}` });
      window.open(href, '_blank');
      // this.$router.push('/admin/workList')
    },
    // 编辑
    edit (index) {
      this.isEdit = true
      this.modalData = JSON.parse(JSON.stringify(this.data1[index]))
      this.isOrgModal = true
    },
    // 删除
    deleteItem (index) {
      const id = this.data1[index].id
      this.$Modal.confirm({
        title: '提示',
        content: `当前机构删除后无法恢复，是否删除？`,
        onOk: async () => {
          const res = await orgRemove(id)
          if (res.code !== 200) {
            this.$Message.error(res.message)
            return false
          }
          this.$Message.success(`当前机构删除成功`)
          this.getList()
        }
      })
    },
    // 新建机构
    add () {
      this.isEdit = false
      this.isOrgModal = true
    },
    formatData (data) {
      const selfData = []
      data.forEach((val, ind) => {
        val.principal = val.name
        val.handle = [OrgMsg.edit, OrgMsg.remove]
        selfData.push(val)
      })
      this.data1 = selfData
    },
    async getOrgList () {
      const queryData = this.$route.query
      const params = {
        page: queryData?.page ?? this.currPage,
        keyword: queryData?.keyword ?? this.keyword,
        page_size: queryData?.pageSize ?? this.pageSize
      }
      const res = await orgList(params)
      handleRes(res, '', () => {
        this.keyword = queryData?.keyword ?? this.keyword
        this.totalCount = res.data?.total ?? 1
        this.currPage = res.data?.current_page ?? 1
        this.pageSize = Number(res.data?.per_page)
        this.formatData(res.data.data)
      }, '获取机构列表失败，请稍候再试')
      handleResAuthor(res.code, '')
    },
    autoSchoolList (str) {
      if (str && str !== '') {
        this.autoData = this.originData.map(value => value.name).filter((val) => {
          if (val.includes(str)) {
            return val
          }
        })
      }
    },
    async schoolList () {
      const res = await getOrgList()
      if (res.code !== 200) {
        this.$Message.error(res.message)
        return false
      }
      this.originData = res.data
      this.schoolDataList = res.data.map(val => ({ id: val.university_id, name: val.name }))
    },
    getList () {
      this.isLoading = true
      const params = {
        keyword: this.keyword.trim(),
        page: this.currPage,
        page_size: this.pageSize
      }
      getSuperOrg(params).then(res => {
        handleResAuthor(res.code, res.message)
        this.data1 = Object.assign(res.data.data || [])
        this.currPage = res.data.current_page
        this.pageSize = res.data.per_page
        this.totalCount = res.data.total
        this.isLoading = false
      }).catch(e => {
        console.error(e)
      })
    },
    clearSelect () {
      this.keyword = ''
      this.autoData = []
    }
  },
  created () {
    this.schoolList()
    this.getList()
  },
  computed: {
    ...mapState({
      tableHeight: state => state.tableHeight
    })
  }
}
</script>

<style lang="scss" scoped>
.topButtDiv {
  display: inline-block;
  vertical-align: middle;
  height: 34px;
  line-height: 34px;
  margin: 5px;
  ::v-deep .topSearchDiv{
    display: inline-block;
    vertical-align: middle;
  }
  .myAutoInput{
    vertical-align: top;
    height: 50px;
  }
  .activeList{
    width: 100%;
  }
  .searchBut{
    margin: 0!important;
    vertical-align: top;
  }
}
.rightContent .topButtDiv ::v-deep button{
  margin:0 0 0 5px;
}
::v-deep .divNormal{
  display: inline-block;
  border:1px solid var(--baseSkyBlue);
  border-radius: 3px;
  padding: 2px 5px;
  color: var(--baseSkyBlue);
}
::v-deep .divBlockup{
  display: inline-block;
  border:1px solid var(--baseYellow);
  border-radius: 3px;
  padding: 2px 5px;
  color: var(--baseYellow);
}
::v-deep .divOverdue{
  display: inline-block;
  border:1px solid var(--baseGray);
  border-radius: 3px;
  padding: 2px 5px;
  color: var(--baseGray);
}
.ivu-auto-complete.ivu-select-dropdown{
  z-index: 998!important;
  max-height: 300px!important;
}
.rightContent .topButtDiv .topSearch {
  ::v-deep .ivu-input-icon{
    margin-right: 0;
    right: 0;
  }
}
.myAutoInput {}
::v-deep .ivu-auto-complete {

  width: 35rem;
  height: 50% !important;
}
::v-deep .ivu-select-dropdown-list {
  height: 100% !important;
  overflow-y: scroll !important;
}
::v-deep .ivu-page-item-jump-next:after {
    content: "\2022\2022\2022";
    display: block;
    letter-spacing: 1px;
    color: #ccc;
    text-align: center;
}
</style>
<style lang="scss">
</style>
